// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio {
  --border-color: var(--ion-color-primary, #3880ff);
  --color: var(--ion-color-primary, #3880ff);
  --background: var(--ion-color-light, #fff);
  --size: 0px;
  --border-width: 2px;
  --inner-border-color: var(--ion-color-light, #fff);
}

.cursor-no {
  pointer-events: none;
}

.radio-icon {
  border-radius: 50%;
  border-style: solid;
  border-width: var(--border-width);
  border-color: var(--border-color);
  background: var(--background);
  width: var(--size);
  height: var(--size);
  display: flex;
  align-items: center;
  justify-content: center;
}

.radio-ios .radio-icon {
  width: 22px;
  height: 22px;
}

.radio-label {
  white-space: normal;
}

.content {
  padding: 10px;
}

.description-text {
  font-size: 15px;
  padding-left: 20px;
  padding-right: 20px;
}

.radio-button {
  margin-left: 10px;
}

.item {
  padding: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/w2g/w2g.scss"],"names":[],"mappings":"AACA;EACI,iDAAA;EACA,0CAAA;EACA,0CAAA;EACA,WAAA;EACA,mBAAA;EACA,kDAAA;AAAJ;;AAIE;EACE,oBAAA;AADJ;;AAKE;EACE,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,iCAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;;AAKE;EACE,WAAA;EACA,YAAA;AAFJ;;AAKE;EACE,mBAAA;AAFJ;;AAKE;EACE,aAAA;AAFJ;;AAKE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;;AAME;EACE,iBAAA;AAHJ;;AAME;EACE,aAAA;AAHJ","sourcesContent":["// /* Apply styles for ion-radio to look like Android on iOS */\nion-radio {\n    --border-color: var(--ion-color-primary, #3880ff);\n    --color: var(--ion-color-primary, #3880ff);\n    --background: var(--ion-color-light, #fff);\n    --size: 0px;\n    --border-width: 2px;\n    --inner-border-color: var(--ion-color-light, #fff);\n  }\n\n\n  .cursor-no {\n    pointer-events: none;\n  }\n\n\n  .radio-icon {\n    border-radius: 50%;\n    border-style: solid;\n    border-width: var(--border-width);\n    border-color: var(--border-color);\n    background: var(--background);\n    width: var(--size);\n    height: var(--size);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .radio-ios .radio-icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  .radio-label {\n    white-space: normal;\n  }\n\n  .content {\n    padding: 10px;\n  }\n\n  .description-text {\n    font-size: 15px;\n    padding-left: 20px;\n    padding-right: 20px;\n\n  }\n\n  .radio-button {\n    margin-left: 10px;\n  }\n\n  .item {\n    padding: 15px;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
